export default {
	baseUrl: 'springbootweoo206o/',
	name: '/springbootweoo206o',
	indexNav: [
		{
			name: '医生',
			url: '/index/yisheng',
		},
		{
			name: '药方信息',
			url: '/index/yaofangxinxi',
		},
		{
			name: '药品信息',
			url: '/index/yaopinxinxi',
		},
		{
			name: '中医知识',
			url: '/index/zhongyizhishi',
		},
		{
			name: '在线论坛',
			url: '/index/forum'
		}, 
	],
	cateList: [
		{
			name: '医生',
			refTable: 'keshifenlei',
			refColumn: 'keshifenlei',
		},
		{
			name: '药品信息',
			refTable: 'yaopinfenlei',
			refColumn: 'yaopinfenlei',
		},
		{
			name: '中医知识',
			refTable: 'zhishileixing',
			refColumn: 'zhishileixing',
		},
		{
			name: '在线论坛',
			refTable: 'forumtype',
			refColumn: 'typename',
		},
	]
}
